export const SECONDS = 1000;
export const MINUTES = 60000;
export const HOURS = 3600000;
export const HOUR = 3600000;

export type TimeUnit = 1000 | 60000 | 3600000;
